import config from 'common/config/config';

export const isCognitoEnabled = config.isCognitoEnabled;
